import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import POSSaleRegistrationPanel from '../../../components/Sales/panels/POSSaleRegistrationPanel';
// import SaleRegistrationPanel from '../../../components/Sales/panels/SaleRegistrationPanel';
import POSLayout from '../../../layout/POSLayout';

const SaleRegister = () => {
  return (
    <POSLayout>
      <BreadcrumbTwo />
      {/* <SaleRegistrationPanel />  */}
      <POSSaleRegistrationPanel /> 
    </POSLayout>
  );
};

export default SaleRegister;
